module.exports = __webpack_public_path__ + "img/BCPT.aba20a04.svg";